import { Parser } from '~/api';
import { ServerSubdomain } from '~/api/models';
import RequestService from './request';

interface WebServingRequest {
    allocation_id: string;
    ssl_mode: string;
}

interface CreateDomainRequest {
    type: 'subdomain' | 'custom';
    name?: string | null;
    domain_id?: string | null;
    allocation_id?: string | null;
    custom_domain?: string | null;
    web?: WebServingRequest | null;
}

class DomainsService {
    getAll(req: PaginatableRequest): Promise<ListResponse> {
        return RequestService.get('/servers/:server/domains', {
            ...req,
            include: ['allocation', 'webAllocation'],
        }).then(Parser.parse);
    }

    available(data: { search?: string } = {}): Promise<ListResponse> {
        return RequestService.get('/servers/:server/domains/available', {
            ...(data.search ? { 'filter[name]': data.search } : {}),
        }).then(Parser.parse);
    }

    create(data: CreateDomainRequest): Promise<ServerSubdomain> {
        return RequestService.post('/servers/:server/domains', data).then(Parser.parse);
    }

    updateWeb(data: { id: string; web: WebServingRequest | null }): Promise<ServerSubdomain> {
        return RequestService.put(`/servers/:server/domains/${data.id}/web`, { web: data.web }).then(Parser.parse);
    }

    delete(data: { id: string }): Promise<void> {
        return RequestService.delete(`/servers/:server/domains/${data.id}`);
    }

    status(data: { id: string }): Promise<DomainStatus> {
        return RequestService.get(`/servers/:server/domains/${data.id}/status`);
    }

    dnsProvider(data: { hostname: string }): Promise<DnsProviderGuidance> {
        return RequestService.get('/servers/:server/domains/dns-provider', { hostname: data.hostname });
    }

    dnsProviderApply(data: { hostname: string }): Promise<{ url: string }> {
        return RequestService.get('/servers/:server/domains/dns-provider/apply', { hostname: data.hostname });
    }
}

export interface DnsProviderGuidance {
    zone: string | null;
    provider: string | null;
    provider_name: string | null;
    dashboard_url: string | null;
    dns_only_required: boolean;
    domain_connect: boolean;
}

export interface DomainStatus {
    dns: {
        status: 'managed' | 'ok' | 'mismatch' | 'unresolved';
        expected: string;
        resolved: string[] | string | null;
    };
    tls: {
        issued: boolean;
        trusted?: boolean;
        expires_at?: string | null;
        issuer?: string;
        error?: string;
    } | null;
}

export default new DomainsService();
